<template>
  <v-row>
    <v-col class="justify-center">
      <!-- Input Value: {{ text || "Nothing" }}
      <StreamBarcodeReader
        v-if="isview"
        @close="onClosed"
        @decode="(a) => onDecode(a)"
        @loaded="() => onLoaded()"
        @interface="getChildInterface"
      ></StreamBarcodeReader>  -->
      <v-scandit license-key="AYIxcQRIJqUaM/oy1CWfIQAOoFFnHmdgKWbYMkJOjfz6I9BWOmOtNv5pQYVzR+7B9mtXNC5aftigQCPog3QiHihBXIboYEdbggq8dlFn4oEZahD/HDDDyPQJa30rGsYF9ATU9pUB1RvKQ1s0pQdJN1AvM3Pg5UWxr8uuHkT7Ehs5bbbmb/CVvi/eY/uBjioED+Z/KDdWgeRRv1qfEU826klRpxMlDMb2BsY5+q+Y4dRDTdQmdgDs2nvjL73lZsIzJYDEpfH1sYxwoKR6OZAZfFhv1sRcR9tx0HpWqdi4npopoL/ZpHyuUr/5+RNlT3Sw2krHcwuaFgagHP3s/yk4mOq/SVamfOnh1gMxaJKo/IJzDPs2UppNjWD6+kIujTfD0YzpM4pQHtPfGyzXAfkeNCUFJeh0hVnxop6jYNfUkA9IiUXeuHeIzpOK4/9MECk6s9lKOteAbHO3BIfic86OdJfc7O0L82Ifx4WQ/mN/D3a/5gVGqglUdwQ3Qkz4GLKEDMsc11j2HecIk6Oao9mNYCDkux4BogZSiepZQ6pfDGsNB9CnwRqe8PQNvtgFYkydCLQpdIGG4CcymK31V1b1BHM8pNrgAl1t/7JtcBOoWYIOnibzEUdHHwT7AQVcTXqiZ94F/hL6WIMznPF3OAFGW4jA1X+Cxi1R2AYHsREuH4ROpdQVi0j0qwvQgWqUotU1vhajyx/96yPj9xRW1639XNL2nm9bLvzjNsKbwsfazYu7JeksUnUKmrX0ld2HeGEWXr1jTI+2BFQvAiWrsHlpOxdnsGI/vzXKhhtGrQZI9I2MZ6iLHEavsR2Hz9TgAQ==" 
           :configuration-options="{ engineLocation: 'https://cdn.jsdelivr.net/npm/scandit-sdk@5.x/build/' }"
           :scan-settings="{ enabledSymbologies: ['code39', 'code128','pdf417'] }"
           
           v-on:scan="(barcode) => onDecode(barcode.barcodes[0].data)" />

      <!-- <div>
        v-on:barcodePicker="(barcodePicker) => { console.log(barcodePicker); }"
        <v-quagga :onDetected="logIt" :readerSize="readerSize" :readerTypes="['code_128_reader']"></v-quagga>
      </div>
       -->
    </v-col>
  </v-row>
</template>

<script>
// import StreamBarcodeReader from "../components/StreamBarcodeScanner.vue";


// register component 'v-quagga'
// Vue.use(VueQuagga);

export default {
  name: "Scanner",
  

  components: {
    // StreamBarcodeReader,
    // VueQuagga
  },

  data() {
    return {
      text: "",
      id: null,
      isview: true,
      barcode:"",
      // readerSize: {
      //   width: 640,
      //   height: 490
      // },
      // detecteds: [],
    };
  },
  props: {
    msg: String,
  },
  childInterface: {
    reset: () => {},
  },
  created () {
    // Add barcode scan listener and pass the callback function
    this.$barcodeScanner.init(this.onBarcodeScanned)
  },
    destroyed () {
    // Remove listener when component is destroyed
    this.$barcodeScanner.destroy()
  },
  mounted() {
     this.emitInterface();

  },
  methods: {

    onBarcodeScanned (barcode) {
      console.log("barcode : " );
      console.log(barcode);
      // do something...
    },
    resetBarcode () {
      this.barcode = this.$barcodeScanner.getPreviousCode()
      
      // do something...
    },
    onDecode(a) {
      console.log(a);
      this.text = a;
      localStorage.SearchTxt = a.trim();
      this.isview = false;

      this.$emit("close-dialog", a);
      if (this.id) clearTimeout(this.id);
      this.id = setTimeout(() => {
        if (this.text === a) {
          this.text = "";
        }
      }, 100);
    },
    onLoaded() {
      console.log("load");
    },
    onClosed() {
      console.log("onClosed");
      this.isview = false;
    },
    getChildInterface(childInterface) {
        this.$options.childInterface = childInterface;
      },
    closeStream() {
      this.isview = false;
      this.$options.childInterface.reset();
    },
    emitInterface() {
      this.$emit("interface", {
        closeStream: () => this.closeStream(),
      });
    },
  },
};
</script>